// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"9936d47b","1587":"9936d47b","2754":"9936d47b","2960":"9936d47b","3450":"9936d47b","9357":"9936d47b"}[chunkId] + ".chunk.css";
};